import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73e2bb3d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "card-body p-9" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "form-group d-flex flex-wrap" }
const _hoisted_9 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group d-flex flex-wrap" }
const _hoisted_12 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group d-flex flex-wrap" }
const _hoisted_16 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group d-flex align-items-center flex-wrap" }
const _hoisted_19 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_20 = { class: "el-form-item__content" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "form-group d-flex flex-wrap" }
const _hoisted_24 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "form-group d-flex flex-wrap" }
const _hoisted_27 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1))
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-md-12" }
const _hoisted_31 = { class: "form-group d-flex flex-wrap" }
const _hoisted_32 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_33 = { class: "el-form-item__content" }
const _hoisted_34 = {
  key: 0,
  class: "row"
}
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = { class: "form-group d-flex flex-wrap" }
const _hoisted_37 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "form-group d-flex flex-wrap" }
const _hoisted_40 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-md-6" }
const _hoisted_43 = { class: "form-group d-flex flex-wrap" }
const _hoisted_44 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_45 = { class: "col-md-6" }
const _hoisted_46 = { class: "form-group d-flex flex-wrap" }
const _hoisted_47 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-md-6" }
const _hoisted_50 = { class: "form-group d-flex flex-wrap" }
const _hoisted_51 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_52 = { class: "col-md-6" }
const _hoisted_53 = { class: "form-group d-flex flex-wrap" }
const _hoisted_54 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_55 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1))
const _hoisted_57 = {
  key: 0,
  type: "button",
  class: "btn btn-light-primary me-2",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_confirm_fulfillment_order"
}
const _hoisted_58 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_59 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_60 = ["disabled"]
const _hoisted_61 = { class: "indicator-label" }
const _hoisted_62 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_63 = { class: "indicator-progress" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_65 = {
  key: 3,
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_66 = { class: "indicator-label" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1))
const _hoisted_68 = { class: "indicator-progress" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_70 = { class: "card mb-5 mb-xl-10" }
const _hoisted_71 = { class: "card-header" }
const _hoisted_72 = { class: "card-title m-0" }
const _hoisted_73 = { class: "fw-boldest m-0" }
const _hoisted_74 = { class: "card-body p-9" }
const _hoisted_75 = { class: "row" }
const _hoisted_76 = { class: "col-md-6" }
const _hoisted_77 = { class: "form-group d-flex flex-wrap" }
const _hoisted_78 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_79 = { class: "col-md-6" }
const _hoisted_80 = { class: "form-group d-flex flex-wrap" }
const _hoisted_81 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_82 = { class: "col-md-6" }
const _hoisted_83 = { class: "form-group d-flex flex-wrap" }
const _hoisted_84 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1))
const _hoisted_86 = { class: "row" }
const _hoisted_87 = { class: "col-md-6" }
const _hoisted_88 = { class: "form-group d-flex flex-wrap" }
const _hoisted_89 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_90 = { class: "row" }
const _hoisted_91 = { class: "col-md-6" }
const _hoisted_92 = { class: "form-group d-flex flex-wrap" }
const _hoisted_93 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_94 = { class: "col-md-6" }
const _hoisted_95 = { class: "form-group d-flex flex-wrap" }
const _hoisted_96 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_97 = { class: "col-md-6" }
const _hoisted_98 = { class: "form-group d-flex flex-wrap" }
const _hoisted_99 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_100 = { class: "col-md-12" }
const _hoisted_101 = { class: "form-group d-flex flex-wrap" }
const _hoisted_102 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_103 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1))
const _hoisted_105 = {
  key: 0,
  type: "button",
  class: "btn btn-light-primary me-2",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_confirm_fulfillment_order"
}
const _hoisted_106 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_107 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_108 = ["disabled"]
const _hoisted_109 = { class: "indicator-label" }
const _hoisted_110 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_111 = { class: "indicator-progress" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_113 = {
  key: 3,
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_114 = { class: "indicator-label" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1))
const _hoisted_116 = { class: "indicator-progress" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_118 = { class: "card mb-5 mb-xl-10" }
const _hoisted_119 = { class: "card-header" }
const _hoisted_120 = { class: "card-title m-0" }
const _hoisted_121 = { class: "fw-boldest m-0" }
const _hoisted_122 = { class: "card-body p-9" }
const _hoisted_123 = { class: "row" }
const _hoisted_124 = { class: "col-md-6" }
const _hoisted_125 = { class: "form-group d-flex flex-wrap" }
const _hoisted_126 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_127 = { class: "row" }
const _hoisted_128 = { class: "col-md-6" }
const _hoisted_129 = { class: "form-group d-flex flex-wrap" }
const _hoisted_130 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_131 = { class: "col-md-6" }
const _hoisted_132 = { class: "form-group d-flex flex-wrap" }
const _hoisted_133 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_134 = { class: "d-flex el-input el-input-group el-input-group--append el-input--suffix" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-input-group__append d-flex w-auto flex-center" }, " % ", -1))
const _hoisted_136 = { class: "col-md-12" }
const _hoisted_137 = { class: "form-group d-flex flex-wrap" }
const _hoisted_138 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_139 = { class: "col-md-6" }
const _hoisted_140 = { class: "form-group d-flex flex-wrap" }
const _hoisted_141 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_142 = { class: "col-md-12" }
const _hoisted_143 = { class: "form-group d-flex flex-wrap" }
const _hoisted_144 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_145 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1))
const _hoisted_147 = {
  key: 0,
  type: "button",
  class: "btn btn-light-primary me-2",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_confirm_fulfillment_order"
}
const _hoisted_148 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_149 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_150 = ["disabled"]
const _hoisted_151 = { class: "indicator-label" }
const _hoisted_152 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_153 = { class: "indicator-progress" }
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_155 = {
  key: 3,
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_156 = { class: "indicator-label" }
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1))
const _hoisted_158 = { class: "indicator-progress" }
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_160 = { class: "card mb-5 mb-xl-10" }
const _hoisted_161 = { class: "card-header" }
const _hoisted_162 = { class: "card-title m-0" }
const _hoisted_163 = { class: "fw-boldest m-0" }
const _hoisted_164 = { class: "card-body p-9" }
const _hoisted_165 = { class: "row" }
const _hoisted_166 = { class: "col-md-6" }
const _hoisted_167 = { class: "form-group d-flex flex-wrap" }
const _hoisted_168 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_169 = { class: "col-md-6" }
const _hoisted_170 = { class: "form-group d-flex flex-wrap" }
const _hoisted_171 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_172 = { class: "row" }
const _hoisted_173 = { class: "col-md-6" }
const _hoisted_174 = { class: "form-group d-flex flex-wrap" }
const _hoisted_175 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_176 = { class: "col-md-6" }
const _hoisted_177 = { class: "form-group d-flex flex-wrap" }
const _hoisted_178 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_179 = { class: "col-md-6" }
const _hoisted_180 = { class: "form-group d-flex flex-wrap" }
const _hoisted_181 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_182 = { class: "col-md-6" }
const _hoisted_183 = { class: "form-group d-flex flex-wrap" }
const _hoisted_184 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_185 = { class: "col-md-12" }
const _hoisted_186 = { class: "form-group d-flex flex-wrap" }
const _hoisted_187 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_188 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1))
const _hoisted_190 = {
  key: 0,
  type: "button",
  class: "btn btn-light-primary me-2",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_confirm_fulfillment_order"
}
const _hoisted_191 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_192 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_193 = ["disabled"]
const _hoisted_194 = { class: "indicator-label" }
const _hoisted_195 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_196 = { class: "indicator-progress" }
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_198 = {
  key: 3,
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_199 = { class: "indicator-label" }
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1))
const _hoisted_201 = { class: "indicator-progress" }
const _hoisted_202 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_203 = { class: "card mb-5 mb-xl-10" }
const _hoisted_204 = { class: "card-header" }
const _hoisted_205 = { class: "card-title m-0" }
const _hoisted_206 = { class: "fw-boldest m-0" }
const _hoisted_207 = { class: "card-body p-9" }
const _hoisted_208 = { class: "row" }
const _hoisted_209 = { class: "col-md-6" }
const _hoisted_210 = { class: "form-group d-flex flex-wrap" }
const _hoisted_211 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_212 = { class: "col-md-6" }
const _hoisted_213 = { class: "form-group d-flex flex-wrap" }
const _hoisted_214 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_215 = { class: "row" }
const _hoisted_216 = { class: "col-md-6" }
const _hoisted_217 = { class: "form-group d-flex flex-wrap" }
const _hoisted_218 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_219 = { class: "col-md-6" }
const _hoisted_220 = { class: "form-group d-flex flex-wrap" }
const _hoisted_221 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_222 = { class: "col-md-6" }
const _hoisted_223 = { class: "form-group d-flex flex-wrap" }
const _hoisted_224 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_225 = { class: "col-md-6" }
const _hoisted_226 = { class: "form-group d-flex flex-wrap" }
const _hoisted_227 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_228 = { class: "col-md-12" }
const _hoisted_229 = { class: "form-group d-flex flex-wrap" }
const _hoisted_230 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_231 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_232 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1))
const _hoisted_233 = {
  key: 0,
  type: "button",
  class: "btn btn-light-primary me-2",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_confirm_fulfillment_order"
}
const _hoisted_234 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_235 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_236 = ["disabled"]
const _hoisted_237 = { class: "indicator-label" }
const _hoisted_238 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_239 = { class: "indicator-progress" }
const _hoisted_240 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_241 = {
  key: 3,
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_242 = { class: "indicator-label" }
const _hoisted_243 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1))
const _hoisted_244 = { class: "indicator-progress" }
const _hoisted_245 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_246 = { class: "card mb-5 mb-xl-10" }
const _hoisted_247 = { class: "card-header" }
const _hoisted_248 = { class: "card-title m-0" }
const _hoisted_249 = { class: "fw-boldest m-0" }
const _hoisted_250 = { class: "card-body p-9" }
const _hoisted_251 = ["onClick"]
const _hoisted_252 = { class: "svg-icon svg-icon-3" }
const _hoisted_253 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_254 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1))
const _hoisted_255 = {
  key: 0,
  type: "button",
  class: "btn btn-light-primary me-2",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_confirm_fulfillment_order"
}
const _hoisted_256 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_257 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_258 = ["disabled"]
const _hoisted_259 = { class: "indicator-label" }
const _hoisted_260 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_261 = { class: "indicator-progress" }
const _hoisted_262 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_263 = {
  key: 3,
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_264 = { class: "indicator-label" }
const _hoisted_265 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1))
const _hoisted_266 = { class: "indicator-progress" }
const _hoisted_267 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_common_channel_option = _resolveComponent("common-channel-option")!
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_product_info = _resolveComponent("product-info")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_sku_info = _resolveComponent("sku-info")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_CancelFulfillmentOrderModal = _resolveComponent("CancelFulfillmentOrderModal")!
  const _component_ConfirmFulfillmentOrderModal = _resolveComponent("ConfirmFulfillmentOrderModal")!
  const _component_ShowFulfillmentOrderItemDetailModal = _resolveComponent("ShowFulfillmentOrderItemDetailModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      onSubmit: _cache[60] || (_cache[60] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
      rules: _ctx.rules,
      model: _ctx.formData,
      ref: "formRef"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.t("fulfillmentOrder.identifier")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.t("fulfillmentOrder.fulfillmentOrderNumber")), 1),
                  _createVNode(_component_el_form_item, { prop: "fulfillment_order_identifier.fulfillment_order_number" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: 
                    _ctx.formData.fulfillment_order_identifier
                      .fulfillment_order_number
                  ,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((
                    _ctx.formData.fulfillment_order_identifier
                      .fulfillment_order_number
                  ) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("fulfillmentOrder.fulfillmentOrderCreatedDate")), 1),
                  _createVNode(_component_el_form_item, { prop: "fulfillment_order_identifier.created_at" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formData.fulfillment_order_identifier.created_at,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.fulfillment_order_identifier.created_at) = $event)),
                        type: "datetime",
                        style: {"width":"100%"},
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("fulfillmentOrder.externalOrderNumber")), 1),
                  _createVNode(_component_el_form_item, { prop: "fulfillment_order_identifier.external_order_number" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: 
                    _ctx.formData.fulfillment_order_identifier.external_order_number
                  ,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((
                    _ctx.formData.fulfillment_order_identifier.external_order_number
                  ) = $event)),
                        type: "text",
                        placeholder: _ctx.t('common.plsEnter'),
                        clearable: ""
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.t("fulfillmentOrder.fulfillmentOrderStatus")), 1),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge uppercase", 
                    _ctx.fulfillmentOrderstatusClass(
                      _ctx.formData.fulfillment_order_identifier.status
                    )
                  ])
                    }, _toDisplayString(_ctx.options.fulfillment_order_status.get(
                      _ctx.formData.fulfillment_order_identifier.status
                    )), 3)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.t("fulfillmentOrder.salesOrderIdentifier")), 1),
                  _createVNode(_component_el_form_item, { prop: "fulfillment_order_identifier.sale_order_number" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: 
                    _ctx.formData.fulfillment_order_identifier.sale_order_number
                  ,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((
                    _ctx.formData.fulfillment_order_identifier.sale_order_number
                  ) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.t("fulfillmentOrder.estimatedDelayDays")), 1),
                  _createVNode(_component_el_form_item, { prop: "fulfillment_order_identifier.estimated_delay_days" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: 
                    _ctx.formData.fulfillment_order_identifier.estimated_delay_days
                  ,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((
                    _ctx.formData.fulfillment_order_identifier.estimated_delay_days
                  ) = $event)),
                        modelModifiers: { number: true },
                        type: "number",
                        placeholder: _ctx.t('common.plsEnter'),
                        clearable: ""
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("h3", null, _toDisplayString(_ctx.t("fulfillmentOrder.fulfillmentTargetProfile")), 1),
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.t("fulfillmentOrder.fulfillmentSource")), 1),
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_el_radio_group, {
                      modelValue: 
                    _ctx.formData.fulfillment_order_identifier.fulfillment_type
                  ,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((
                    _ctx.formData.fulfillment_order_identifier.fulfillment_type
                  ) = $event)),
                      size: "mini",
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.fulfillment_type, (item) => {
                          return (_openBlock(), _createBlock(_component_el_radio, {
                            key: item.value,
                            label: item.value
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ])
            ]),
            (_ctx.formData.fulfillment_order_identifier.warehouse !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.t("warehouse.warehouse")), 1),
                      _createVNode(_component_el_form_item, { prop: "fulfillment_order_identifier.warehouse" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.formData.fulfillment_order_identifier.warehouse,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.fulfillment_order_identifier.warehouse) = $event)),
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                            clearable: "",
                            style: {"width":"100%"},
                            disabled: "",
                            placeholder: " "
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.destination, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.t("inventory.inventoryType")), 1),
                      _createVNode(_component_el_form_item, { prop: "fulfillment_order_identifier.inventory_type" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.formData.fulfillment_order_identifier.inventory_type,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.fulfillment_order_identifier.inventory_type) = $event)),
                            filterable: "",
                            clearable: "",
                            style: {"width":"100%"},
                            disabled: "",
                            placeholder: " "
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.inventory_type, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.t("fulfillmentOrder.merchantName")), 1),
                  _createVNode(_component_el_form_item, { prop: "merchant_profile.merchant" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.merchant_profile.merchant,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.merchant_profile.merchant) = $event)),
                        filterable: "",
                        clearable: "",
                        "remote-show-suffix": "",
                        remote: "",
                        "remote-method": _ctx.searchMerchantSourceItems,
                        loading: _ctx.options.merchantLoading,
                        onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.getSalesChannelsData($event, true))),
                        placeholder: _ctx.t('common.plsSelect'),
                        disabled: 
                    _ctx.formData.fulfillment_order_identifier.warehouse !== 0
                  
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.merchant, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "remote-method", "loading", "placeholder", "disabled"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.t("fulfillmentOrder.channel")), 1),
                  _createVNode(_component_el_form_item, { prop: "merchant_profile.channel" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.merchant_profile.channel,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.merchant_profile.channel) = $event)),
                        filterable: "",
                        clearable: "",
                        loading: _ctx.options.channelLoading,
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"},
                        disabled: 
                    _ctx.formData.fulfillment_order_identifier.warehouse !== 0
                  
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.channel, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_common_channel_option, { channelOption: item }, null, 8, ["channelOption"])
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "loading", "placeholder", "disabled"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.t("fulfillmentOrder.merchantCountry")), 1),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.merchant_profile.merchant,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.merchant_profile.merchant) = $event)),
                        filterable: "",
                        remote: "",
                        "reserve-keyword": "",
                        style: {"width":"100%"},
                        disabled: "",
                        placeholder: " "
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.merchant, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.entity_data.__show.country_iso_2,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.t("fulfillmentOrder.estimatedDeliveryDate")), 1),
                  _createVNode(_component_el_form_item, { prop: "merchant_profile.estimated_delivery_duration" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: 
                    _ctx.formData.merchant_profile.estimated_delivery_duration
                  ,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((
                    _ctx.formData.merchant_profile.estimated_delivery_duration
                  ) = $event)),
                        type: "date",
                        placeholder: _ctx.t('common.pickDate'),
                        style: {"width":"100%"},
                        onChange: _cache[13] || (_cache[13] = ($event: any) => (
                    _ctx.commonChangeDefaultDate(
                      $event,
                      _ctx.formData,
                      'merchant_profile',
                      'estimated_delivery_duration'
                    )
                  ))
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary align-self-center me-2",
              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
            }, [
              _hoisted_56,
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
            ]),
            _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
              default: _withCtx(() => [
                (
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Initialized ||
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Assigning ||
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Assigned
            )
                  ? (_openBlock(), _createElementBlock("button", _hoisted_57, [
                      _createElementVNode("span", _hoisted_58, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.confirm")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Initialized ||
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Assigning
            )
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn btn-light-dark me-2",
                      onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.cancelItem && _ctx.cancelItem(...args))),
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#modal_cancel_fulfillment_order"
                    }, [
                      _createElementVNode("span", _hoisted_59, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("fulfillmentOrder.void")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (
              _ctx.formData.fulfillment_order_identifier.status ===
              _ctx.options.FulfillmentOrderStatus.Fulfilled
            )
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      ref: "closeButton",
                      type: "button",
                      class: "btn btn-light-primary me-2",
                      onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.closeItem && _ctx.closeItem(...args))),
                      disabled: _ctx.options.closeDisabled
                    }, [
                      _createElementVNode("span", _hoisted_61, [
                        _createElementVNode("span", _hoisted_62, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.t("common.close")), 1)
                      ]),
                      _createElementVNode("span", _hoisted_63, [
                        _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                        _hoisted_64
                      ])
                    ], 8, _hoisted_60))
                  : _createCommentVNode("", true),
                (
              _ctx.formData.fulfillment_order_identifier.status != 0 &&
              _ctx.formData.fulfillment_order_identifier.status !=
                _ctx.options.FulfillmentOrderStatus.Initialized
            )
                  ? (_openBlock(), _createElementBlock("button", _hoisted_65, [
                      _createElementVNode("span", _hoisted_66, [
                        _hoisted_67,
                        _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
                      ]),
                      _createElementVNode("span", _hoisted_68, [
                        _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                        _hoisted_69
                      ])
                    ], 512))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_70, [
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("h3", _hoisted_73, _toDisplayString(_ctx.t("salesOrder.distribution")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_74, [
            _createElementVNode("div", _hoisted_75, [
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.t("salesOrder.distributionManager")), 1),
                  _createVNode(_component_el_form_item, { prop: "distribution_profile.sales_manager" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        class: "w-100",
                        modelValue: _ctx.formData.distribution_profile.sales_manager,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.distribution_profile.sales_manager) = $event)),
                        disabled: "",
                        placeholder: " "
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.sales_manager, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("label", _hoisted_81, _toDisplayString(_ctx.t("salesOrder.distributionChannel")), 1),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        class: "w-100",
                        modelValue: _ctx.formData.distribution_profile.distribution_channel,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.distribution_profile.distribution_channel) = $event)),
                        disabled: "",
                        placeholder: " "
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.distribution_channel, (group) => {
                            return (_openBlock(), _createBlock(_component_el_option_group, {
                              key: group.label,
                              label: group.label
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.children, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("label", _hoisted_84, _toDisplayString(_ctx.t("salesOrder.overallNotice")), 1),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.distribution_profile.overall_notice,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.distribution_profile.overall_notice) = $event)),
                        type: "textarea",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("h3", null, _toDisplayString(_ctx.t("salesOrder.distributionPriority")), 1),
            _hoisted_85,
            _createElementVNode("div", _hoisted_86, [
              _createElementVNode("div", _hoisted_87, [
                _createElementVNode("div", _hoisted_88, [
                  _createElementVNode("label", _hoisted_89, _toDisplayString(_ctx.t("salesOrder.priorityManagement")), 1),
                  _createVNode(_component_el_form_item, { prop: "priority_management.high_priority_order" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_switch, {
                        modelValue: _ctx.formData.priority_management.high_priority_order,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.priority_management.high_priority_order) = $event)),
                        "active-value": _ctx.options.CommonSwtich.Active,
                        "inactive-value": _ctx.options.CommonSwtich.InActive,
                        disabled: ""
                      }, null, 8, ["modelValue", "active-value", "inactive-value"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_90, [
                _createElementVNode("div", _hoisted_91, [
                  _createElementVNode("div", _hoisted_92, [
                    _createElementVNode("label", _hoisted_93, _toDisplayString(_ctx.t("salesOrder.priorityHandling")), 1),
                    _createVNode(_component_el_form_item, { prop: "priority_management.priority_handling" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.priority_management.priority_handling,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.priority_management.priority_handling) = $event)),
                          clearable: "",
                          placeholder: _ctx.t('common.plsSelect'),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.priority_handling, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_94, [
                  _createElementVNode("div", _hoisted_95, [
                    _createElementVNode("label", _hoisted_96, _toDisplayString(_ctx.t("salesOrder.priorityLevel")), 1),
                    _createVNode(_component_el_form_item, { prop: "priority_management.priority_level" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.priority_management.priority_level,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.priority_management.priority_level) = $event)),
                          clearable: "",
                          placeholder: _ctx.t('common.plsSelect'),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.priority_level, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_97, [
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("label", _hoisted_99, _toDisplayString(_ctx.t("salesOrder.exceptionRiskLevel")), 1),
                    _createVNode(_component_el_form_item, { prop: "priority_management.exception_risk_level" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.priority_management.exception_risk_level,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.priority_management.exception_risk_level) = $event)),
                          clearable: "",
                          placeholder: _ctx.t('common.plsSelect'),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.exception_risk_level, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_100, [
                  _createElementVNode("div", _hoisted_101, [
                    _createElementVNode("label", _hoisted_102, _toDisplayString(_ctx.t("salesOrder.priorityNotice")), 1),
                    _createVNode(_component_el_form_item, { prop: "priority_management.priority_notice" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.priority_management.priority_notice,
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.priority_management.priority_notice) = $event)),
                          type: "textarea",
                          placeholder: _ctx.t('common.plsEnter'),
                          clearable: ""
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ], 512), [
              [_vShow, 
            _ctx.formData.priority_management.high_priority_order ===
            _ctx.options.CommonSwtich.Active
          ]
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_103, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary align-self-center me-2",
              onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
            }, [
              _hoisted_104,
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
            ]),
            _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
              default: _withCtx(() => [
                (
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Initialized ||
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Assigning ||
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Assigned
            )
                  ? (_openBlock(), _createElementBlock("button", _hoisted_105, [
                      _createElementVNode("span", _hoisted_106, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.confirm")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Initialized ||
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Assigning
            )
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn btn-light-dark me-2",
                      onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.cancelItem && _ctx.cancelItem(...args))),
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#modal_cancel_fulfillment_order"
                    }, [
                      _createElementVNode("span", _hoisted_107, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("fulfillmentOrder.void")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (
              _ctx.formData.fulfillment_order_identifier.status ===
              _ctx.options.FulfillmentOrderStatus.Fulfilled
            )
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      ref: "closeButton",
                      type: "button",
                      class: "btn btn-light-primary me-2",
                      onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.closeItem && _ctx.closeItem(...args))),
                      disabled: _ctx.options.closeDisabled
                    }, [
                      _createElementVNode("span", _hoisted_109, [
                        _createElementVNode("span", _hoisted_110, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.t("common.close")), 1)
                      ]),
                      _createElementVNode("span", _hoisted_111, [
                        _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                        _hoisted_112
                      ])
                    ], 8, _hoisted_108))
                  : _createCommentVNode("", true),
                (
              _ctx.formData.fulfillment_order_identifier.status != 0 &&
              _ctx.formData.fulfillment_order_identifier.status !=
                _ctx.options.FulfillmentOrderStatus.Initialized
            )
                  ? (_openBlock(), _createElementBlock("button", _hoisted_113, [
                      _createElementVNode("span", _hoisted_114, [
                        _hoisted_115,
                        _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
                      ]),
                      _createElementVNode("span", _hoisted_116, [
                        _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                        _hoisted_117
                      ])
                    ], 512))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_118, [
          _createElementVNode("div", _hoisted_119, [
            _createElementVNode("div", _hoisted_120, [
              _createElementVNode("h3", _hoisted_121, _toDisplayString(_ctx.t("salesOrder.pim")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_122, [
            _createElementVNode("div", _hoisted_123, [
              _createElementVNode("div", _hoisted_124, [
                _createElementVNode("div", _hoisted_125, [
                  _createElementVNode("label", _hoisted_126, _toDisplayString(_ctx.t("salesOrder.additionalPimService")), 1),
                  _createVNode(_component_el_form_item, { prop: "pim_profile.additional_pim_service" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_switch, {
                        modelValue: _ctx.formData.pim_profile.additional_pim_service,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formData.pim_profile.additional_pim_service) = $event)),
                        "active-value": _ctx.options.CommonSwtich.Active,
                        "inactive-value": _ctx.options.CommonSwtich.InActive,
                        disabled: ""
                      }, null, 8, ["modelValue", "active-value", "inactive-value"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_127, [
                _createElementVNode("div", _hoisted_128, [
                  _createElementVNode("div", _hoisted_129, [
                    _createElementVNode("label", _hoisted_130, _toDisplayString(_ctx.t("salesOrder.definiteInventoryType")), 1),
                    _createVNode(_component_el_form_item, { prop: "pim_profile.definite_inventory_source" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.pim_profile.definite_inventory_source,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.formData.pim_profile.definite_inventory_source) = $event)),
                          clearable: "",
                          style: {"width":"100%"},
                          disabled: "",
                          placeholder: " "
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.definite_inventory_source, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_131, [
                  _createElementVNode("div", _hoisted_132, [
                    _createElementVNode("label", _hoisted_133, _toDisplayString(_ctx.t("salesOrder.minimumInventoryRequest")), 1),
                    _createVNode(_component_el_form_item, { prop: "pim_profile.minimum_inventory_request" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_134, [
                          _createVNode(_component_el_input_number, {
                            class: "text-start w-100",
                            modelValue: _ctx.formData.pim_profile.minimum_inventory_request,
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.formData.pim_profile.minimum_inventory_request) = $event)),
                            precision: 0,
                            step: 1,
                            min: 0,
                            controls: false,
                            disabled: ""
                          }, null, 8, ["modelValue"]),
                          _hoisted_135
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_136, [
                  _createElementVNode("div", _hoisted_137, [
                    _createElementVNode("label", _hoisted_138, _toDisplayString(_ctx.t("salesOrder.packageRequirement")), 1),
                    _createVNode(_component_el_form_item, { prop: "pim_profile.package_requirement" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.pim_profile.package_requirement,
                          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.formData.pim_profile.package_requirement) = $event)),
                          type: "textarea",
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_139, [
                  _createElementVNode("div", _hoisted_140, [
                    _createElementVNode("label", _hoisted_141, _toDisplayString(_ctx.t("salesOrder.inventoryConfirmationDate")), 1),
                    _createVNode(_component_el_form_item, { prop: "pim_profile.inventory_confirmation_date" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.formData.pim_profile.inventory_confirmation_date,
                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.formData.pim_profile.inventory_confirmation_date) = $event)),
                          type: "date",
                          style: {"width":"100%"},
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_142, [
                  _createElementVNode("div", _hoisted_143, [
                    _createElementVNode("label", _hoisted_144, _toDisplayString(_ctx.t("salesOrder.additionalPimNotice")), 1),
                    _createVNode(_component_el_form_item, { prop: "pim_profile.additional_pim_notice" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.pim_profile.additional_pim_notice,
                          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.formData.pim_profile.additional_pim_notice) = $event)),
                          type: "textarea",
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ], 512), [
              [_vShow, 
            _ctx.formData.pim_profile.additional_pim_service ===
            _ctx.options.CommonSwtich.Active
          ]
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_145, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary align-self-center me-2",
              onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
            }, [
              _hoisted_146,
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
            ]),
            _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
              default: _withCtx(() => [
                (
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Initialized ||
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Assigning ||
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Assigned
            )
                  ? (_openBlock(), _createElementBlock("button", _hoisted_147, [
                      _createElementVNode("span", _hoisted_148, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.confirm")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Initialized ||
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Assigning
            )
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn btn-light-dark me-2",
                      onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.cancelItem && _ctx.cancelItem(...args))),
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#modal_cancel_fulfillment_order"
                    }, [
                      _createElementVNode("span", _hoisted_149, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("fulfillmentOrder.void")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (
              _ctx.formData.fulfillment_order_identifier.status ===
              _ctx.options.FulfillmentOrderStatus.Fulfilled
            )
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      ref: "closeButton",
                      type: "button",
                      class: "btn btn-light-primary me-2",
                      onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.closeItem && _ctx.closeItem(...args))),
                      disabled: _ctx.options.closeDisabled
                    }, [
                      _createElementVNode("span", _hoisted_151, [
                        _createElementVNode("span", _hoisted_152, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.t("common.close")), 1)
                      ]),
                      _createElementVNode("span", _hoisted_153, [
                        _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                        _hoisted_154
                      ])
                    ], 8, _hoisted_150))
                  : _createCommentVNode("", true),
                (
              _ctx.formData.fulfillment_order_identifier.status != 0 &&
              _ctx.formData.fulfillment_order_identifier.status !=
                _ctx.options.FulfillmentOrderStatus.Initialized
            )
                  ? (_openBlock(), _createElementBlock("button", _hoisted_155, [
                      _createElementVNode("span", _hoisted_156, [
                        _hoisted_157,
                        _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
                      ]),
                      _createElementVNode("span", _hoisted_158, [
                        _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                        _hoisted_159
                      ])
                    ], 512))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_160, [
          _createElementVNode("div", _hoisted_161, [
            _createElementVNode("div", _hoisted_162, [
              _createElementVNode("h3", _hoisted_163, _toDisplayString(_ctx.t("fulfillmentOrder.fulfillmentProfile")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_164, [
            _createElementVNode("div", _hoisted_165, [
              _createElementVNode("div", _hoisted_166, [
                _createElementVNode("div", _hoisted_167, [
                  _createElementVNode("label", _hoisted_168, _toDisplayString(_ctx.t("salesOrder.fulfillmentManager")), 1),
                  _createVNode(_component_el_form_item, { prop: "fulfillment.order_specification.fulfillment_manager" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: 
                    _ctx.formData.fulfillment.order_specification.fulfillment_manager
                  ,
                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((
                    _ctx.formData.fulfillment.order_specification.fulfillment_manager
                  ) = $event)),
                        placeholder: " ",
                        disabled: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.fulfillment_manager, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_169, [
                _createElementVNode("div", _hoisted_170, [
                  _createElementVNode("label", _hoisted_171, _toDisplayString(_ctx.t("salesOrder.additionalFulfillmentService")), 1),
                  _createVNode(_component_el_form_item, { prop: "fulfillment.order_specification.additional_fulfillment_service" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_switch, {
                        modelValue: 
                    _ctx.formData.fulfillment.order_specification
                      .additional_fulfillment_service
                  ,
                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((
                    _ctx.formData.fulfillment.order_specification
                      .additional_fulfillment_service
                  ) = $event)),
                        "active-value": _ctx.options.CommonSwtich.Active,
                        "inactive-value": _ctx.options.CommonSwtich.InActive,
                        disabled: ""
                      }, null, 8, ["modelValue", "active-value", "inactive-value"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_172, [
                _createElementVNode("div", _hoisted_173, [
                  _createElementVNode("div", _hoisted_174, [
                    _createElementVNode("label", _hoisted_175, _toDisplayString(_ctx.t("salesOrder.requriedDocuments")), 1),
                    _createVNode(_component_el_form_item, { prop: "fulfillment.order_specification.required_documents" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "w-100",
                          modelValue: 
                      _ctx.formData.fulfillment.order_specification
                        .required_documents
                    ,
                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((
                      _ctx.formData.fulfillment.order_specification
                        .required_documents
                    ) = $event)),
                          multiple: "",
                          placeholder: " ",
                          disabled: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.required_documents, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_176, [
                  _createElementVNode("div", _hoisted_177, [
                    _createElementVNode("label", _hoisted_178, _toDisplayString(_ctx.t("salesOrder.packingService")), 1),
                    _createVNode(_component_el_form_item, { prop: "fulfillment.order_specification.packaging_service" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "w-100",
                          modelValue: 
                      _ctx.formData.fulfillment.order_specification.packaging_service
                    ,
                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((
                      _ctx.formData.fulfillment.order_specification.packaging_service
                    ) = $event)),
                          placeholder: " ",
                          disabled: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.packaging_service, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_179, [
                  _createElementVNode("div", _hoisted_180, [
                    _createElementVNode("label", _hoisted_181, _toDisplayString(_ctx.t("salesOrder.shippingMode")), 1),
                    _createVNode(_component_el_form_item, { prop: "fulfillment.order_specification.partial_shipment" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_switch, {
                          modelValue: 
                      _ctx.formData.fulfillment.order_specification.partial_shipment
                    ,
                          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((
                      _ctx.formData.fulfillment.order_specification.partial_shipment
                    ) = $event)),
                          "active-value": _ctx.options.CommonDropdownSwtich.Yes,
                          "inactive-value": _ctx.options.CommonDropdownSwtich.No,
                          disabled: ""
                        }, null, 8, ["modelValue", "active-value", "inactive-value"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_182, [
                  _createElementVNode("div", _hoisted_183, [
                    _createElementVNode("label", _hoisted_184, _toDisplayString(_ctx.t("salesOrder.completeOrderManually")), 1),
                    _createVNode(_component_el_form_item, { prop: "fulfillment.order_specification.complete_order_manually" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_switch, {
                          modelValue: 
                      _ctx.formData.fulfillment.order_specification
                        .complete_order_manually
                    ,
                          "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((
                      _ctx.formData.fulfillment.order_specification
                        .complete_order_manually
                    ) = $event)),
                          "active-value": _ctx.options.CommonSwtich.Active,
                          "inactive-value": _ctx.options.CommonSwtich.InActive,
                          disabled: ""
                        }, null, 8, ["modelValue", "active-value", "inactive-value"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_185, [
                  _createElementVNode("div", _hoisted_186, [
                    _createElementVNode("label", _hoisted_187, _toDisplayString(_ctx.t("salesOrder.addtionalFulfillmentNotice")), 1),
                    _createVNode(_component_el_form_item, { prop: "fulfillment.order_specification.fulfillment_notice" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: 
                      _ctx.formData.fulfillment.order_specification
                        .fulfillment_notice
                    ,
                          "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((
                      _ctx.formData.fulfillment.order_specification
                        .fulfillment_notice
                    ) = $event)),
                          type: "textarea",
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ], 512), [
              [_vShow, 
            _ctx.formData.fulfillment.order_specification
              .additional_fulfillment_service === _ctx.options.CommonSwtich.Active
          ]
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_188, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary align-self-center me-2",
              onClick: _cache[44] || (_cache[44] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
            }, [
              _hoisted_189,
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
            ]),
            _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
              default: _withCtx(() => [
                (
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Initialized ||
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Assigning ||
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Assigned
            )
                  ? (_openBlock(), _createElementBlock("button", _hoisted_190, [
                      _createElementVNode("span", _hoisted_191, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.confirm")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Initialized ||
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Assigning
            )
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn btn-light-dark me-2",
                      onClick: _cache[45] || (_cache[45] = 
//@ts-ignore
(...args) => (_ctx.cancelItem && _ctx.cancelItem(...args))),
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#modal_cancel_fulfillment_order"
                    }, [
                      _createElementVNode("span", _hoisted_192, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("fulfillmentOrder.void")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (
              _ctx.formData.fulfillment_order_identifier.status ===
              _ctx.options.FulfillmentOrderStatus.Fulfilled
            )
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      ref: "closeButton",
                      type: "button",
                      class: "btn btn-light-primary me-2",
                      onClick: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => (_ctx.closeItem && _ctx.closeItem(...args))),
                      disabled: _ctx.options.closeDisabled
                    }, [
                      _createElementVNode("span", _hoisted_194, [
                        _createElementVNode("span", _hoisted_195, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.t("common.close")), 1)
                      ]),
                      _createElementVNode("span", _hoisted_196, [
                        _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                        _hoisted_197
                      ])
                    ], 8, _hoisted_193))
                  : _createCommentVNode("", true),
                (
              _ctx.formData.fulfillment_order_identifier.status != 0 &&
              _ctx.formData.fulfillment_order_identifier.status !=
                _ctx.options.FulfillmentOrderStatus.Initialized
            )
                  ? (_openBlock(), _createElementBlock("button", _hoisted_198, [
                      _createElementVNode("span", _hoisted_199, [
                        _hoisted_200,
                        _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
                      ]),
                      _createElementVNode("span", _hoisted_201, [
                        _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                        _hoisted_202
                      ])
                    ], 512))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_203, [
          _createElementVNode("div", _hoisted_204, [
            _createElementVNode("div", _hoisted_205, [
              _createElementVNode("h3", _hoisted_206, _toDisplayString(_ctx.t("salesOrder.settlement")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_207, [
            _createElementVNode("div", _hoisted_208, [
              _createElementVNode("div", _hoisted_209, [
                _createElementVNode("div", _hoisted_210, [
                  _createElementVNode("label", _hoisted_211, _toDisplayString(_ctx.t("salesOrder.settlementManager")), 1),
                  _createVNode(_component_el_form_item, { prop: "settlement.offline_payment_controller" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.settlement.offline_payment_controller,
                        "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.formData.settlement.offline_payment_controller) = $event)),
                        placeholder: " ",
                        disabled: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.offline_payment_controller, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_212, [
                _createElementVNode("div", _hoisted_213, [
                  _createElementVNode("label", _hoisted_214, _toDisplayString(_ctx.t("salesOrder.additionalSettlementService")), 1),
                  _createVNode(_component_el_form_item, { prop: "settlement.offline_payment_controlling" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_switch, {
                        modelValue: _ctx.formData.settlement.offline_payment_controlling,
                        "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.formData.settlement.offline_payment_controlling) = $event)),
                        "active-value": _ctx.options.CommonRequiredSwtich.Requried,
                        "inactive-value": _ctx.options.CommonRequiredSwtich.NotRequried,
                        disabled: ""
                      }, null, 8, ["modelValue", "active-value", "inactive-value"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_215, [
              _createElementVNode("div", _hoisted_216, [
                _createElementVNode("div", _hoisted_217, [
                  _createElementVNode("label", _hoisted_218, _toDisplayString(_ctx.t("salesOrder.trackPaymentStatus")), 1),
                  _createVNode(_component_el_form_item, { prop: "settlement.track_payment_status" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_switch, {
                        modelValue: _ctx.formData.settlement.track_payment_status,
                        "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.formData.settlement.track_payment_status) = $event)),
                        "active-value": _ctx.options.CommonSwtich.Active,
                        "inactive-value": _ctx.options.CommonSwtich.InActive,
                        disabled: ""
                      }, null, 8, ["modelValue", "active-value", "inactive-value"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_219, [
                _createElementVNode("div", _hoisted_220, [
                  _createElementVNode("label", _hoisted_221, _toDisplayString(_ctx.t("salesOrder.applyPaymentDeferral")), 1),
                  _createVNode(_component_el_form_item, { prop: "settlement.apply_payment_deferral" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_switch, {
                        modelValue: _ctx.formData.settlement.apply_payment_deferral,
                        "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.formData.settlement.apply_payment_deferral) = $event)),
                        "active-value": _ctx.options.CommonSwtich.Active,
                        "inactive-value": _ctx.options.CommonSwtich.InActive,
                        disabled: ""
                      }, null, 8, ["modelValue", "active-value", "inactive-value"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_222, [
                _createElementVNode("div", _hoisted_223, [
                  _createElementVNode("label", _hoisted_224, _toDisplayString(_ctx.t("salesOrder.creditRiskControl")), 1),
                  _createVNode(_component_el_form_item, { prop: "settlement.credit_risk_control" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.settlement.credit_risk_control,
                        "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.formData.settlement.credit_risk_control) = $event)),
                        clearable: "",
                        placeholder: " ",
                        disabled: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.credit_risk_control, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_225, [
                _createElementVNode("div", _hoisted_226, [
                  _createElementVNode("label", _hoisted_227, _toDisplayString(_ctx.t("salesOrderOverview.estPaymentReceivedDate")), 1),
                  _createVNode(_component_el_form_item, { prop: "settlement.offline_payment_due_date" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        class: "w-100",
                        modelValue: _ctx.formData.settlement.offline_payment_due_date,
                        "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.formData.settlement.offline_payment_due_date) = $event)),
                        type: "date",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_228, [
                _createElementVNode("div", _hoisted_229, [
                  _createElementVNode("label", _hoisted_230, _toDisplayString(_ctx.t("salesOrder.additionalSettlementNotice")), 1),
                  _createVNode(_component_el_form_item, { prop: "settlement.additional_settlement_notice" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.settlement.additional_settlement_notice,
                        "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.formData.settlement.additional_settlement_notice) = $event)),
                        type: "textarea",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ], 512), [
              [_vShow, _ctx.formData.settlement.offline_payment_controlling == 1]
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_231, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary align-self-center me-2",
              onClick: _cache[54] || (_cache[54] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
            }, [
              _hoisted_232,
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
            ]),
            _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
              default: _withCtx(() => [
                (
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Initialized ||
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Assigning ||
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Assigned
            )
                  ? (_openBlock(), _createElementBlock("button", _hoisted_233, [
                      _createElementVNode("span", _hoisted_234, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.confirm")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Initialized ||
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Assigning
            )
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn btn-light-dark me-2",
                      onClick: _cache[55] || (_cache[55] = 
//@ts-ignore
(...args) => (_ctx.cancelItem && _ctx.cancelItem(...args))),
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#modal_cancel_fulfillment_order"
                    }, [
                      _createElementVNode("span", _hoisted_235, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("fulfillmentOrder.void")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (
              _ctx.formData.fulfillment_order_identifier.status ===
              _ctx.options.FulfillmentOrderStatus.Fulfilled
            )
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      ref: "closeButton",
                      type: "button",
                      class: "btn btn-light-primary me-2",
                      onClick: _cache[56] || (_cache[56] = 
//@ts-ignore
(...args) => (_ctx.closeItem && _ctx.closeItem(...args))),
                      disabled: _ctx.options.closeDisabled
                    }, [
                      _createElementVNode("span", _hoisted_237, [
                        _createElementVNode("span", _hoisted_238, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.t("common.close")), 1)
                      ]),
                      _createElementVNode("span", _hoisted_239, [
                        _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                        _hoisted_240
                      ])
                    ], 8, _hoisted_236))
                  : _createCommentVNode("", true),
                (
              _ctx.formData.fulfillment_order_identifier.status != 0 &&
              _ctx.formData.fulfillment_order_identifier.status !=
                _ctx.options.FulfillmentOrderStatus.Initialized
            )
                  ? (_openBlock(), _createElementBlock("button", _hoisted_241, [
                      _createElementVNode("span", _hoisted_242, [
                        _hoisted_243,
                        _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
                      ]),
                      _createElementVNode("span", _hoisted_244, [
                        _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                        _hoisted_245
                      ])
                    ], 512))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_246, [
          _createElementVNode("div", _hoisted_247, [
            _createElementVNode("div", _hoisted_248, [
              _createElementVNode("h3", _hoisted_249, _toDisplayString(_ctx.t("fulfillmentOrder.fulfilledItems")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_250, [
            _createVNode(_component_el_table, {
              class: "w-100",
              data: _ctx.formData.fulfilled_items,
              size: "small"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: _ctx.t('order.articleInformation'),
                  width: "500"
                }, {
                  default: _withCtx(({ row }) => [
                    _withDirectives(_createVNode(_component_product_info, {
                      gallery: _ctx.getProductIdData(row.sku_identifier)?.gallery,
                      name: _ctx.getProductIdData(row.sku_identifier)?.name,
                      name_en: _ctx.getProductIdData(row.sku_identifier)?.name_en,
                      source_link: _ctx.getProductIdData(row.sku_identifier)?.source_link,
                      brand_id: 
                  _ctx.getProductIdData(row.sku_identifier)?.__show.brand_id
                
                    }, null, 8, ["gallery", "name", "name_en", "source_link", "brand_id"]), [
                      [_directive_loading, _ctx.options.loadingProducts]
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.t('order.articleAttributes')
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_sku_info, {
                      brand_article_no: 
                  _ctx.getProductIdData(row.sku_identifier)?.brand_article_no
                ,
                      color: _ctx.getProductIdData(row.sku_identifier)?.original_color,
                      size: _ctx.getProductIdData(row.sku_identifier)?.__show.size,
                      product_identifier_id: 
                  _ctx.getProductIdData(row.sku_identifier)?.product_identifier_id
                
                    }, null, 8, ["brand_article_no", "color", "size", "product_identifier_id"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.t('fulfillmentOrder.quantity'),
                  prop: "quantity",
                  align: "right"
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: "",
                  width: "100",
                  align: "right"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-3",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#modal_show_fulfillment_order_item_detail",
                      onClick: ($event: any) => (_ctx.handleEditItemDetail(row))
                    }, [
                      _createElementVNode("span", _hoisted_252, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                      ])
                    ], 8, _hoisted_251)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_253, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary align-self-center me-2",
              onClick: _cache[57] || (_cache[57] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
            }, [
              _hoisted_254,
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
            ]),
            _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
              default: _withCtx(() => [
                (
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Initialized ||
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Assigning ||
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Assigned
            )
                  ? (_openBlock(), _createElementBlock("button", _hoisted_255, [
                      _createElementVNode("span", _hoisted_256, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.confirm")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Initialized ||
              _ctx.formData.fulfillment_order_identifier.status ===
                _ctx.options.FulfillmentOrderStatus.Assigning
            )
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn btn-light-dark me-2",
                      onClick: _cache[58] || (_cache[58] = 
//@ts-ignore
(...args) => (_ctx.cancelItem && _ctx.cancelItem(...args))),
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#modal_cancel_fulfillment_order"
                    }, [
                      _createElementVNode("span", _hoisted_257, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("fulfillmentOrder.void")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (
              _ctx.formData.fulfillment_order_identifier.status ===
              _ctx.options.FulfillmentOrderStatus.Fulfilled
            )
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      ref: "closeButton",
                      type: "button",
                      class: "btn btn-light-primary me-2",
                      onClick: _cache[59] || (_cache[59] = 
//@ts-ignore
(...args) => (_ctx.closeItem && _ctx.closeItem(...args))),
                      disabled: _ctx.options.closeDisabled
                    }, [
                      _createElementVNode("span", _hoisted_259, [
                        _createElementVNode("span", _hoisted_260, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.t("common.close")), 1)
                      ]),
                      _createElementVNode("span", _hoisted_261, [
                        _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                        _hoisted_262
                      ])
                    ], 8, _hoisted_258))
                  : _createCommentVNode("", true),
                (
              _ctx.formData.fulfillment_order_identifier.status != 0 &&
              _ctx.formData.fulfillment_order_identifier.status !=
                _ctx.options.FulfillmentOrderStatus.Initialized
            )
                  ? (_openBlock(), _createElementBlock("button", _hoisted_263, [
                      _createElementVNode("span", _hoisted_264, [
                        _hoisted_265,
                        _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
                      ]),
                      _createElementVNode("span", _hoisted_266, [
                        _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                        _hoisted_267
                      ])
                    ], 512))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["rules", "model"]),
    _createVNode(_component_CancelFulfillmentOrderModal, {
      onUpdateList: _ctx.getFormReset,
      id: Number(_ctx.cancelId)
    }, null, 8, ["onUpdateList", "id"]),
    _createVNode(_component_ConfirmFulfillmentOrderModal, {
      onUpdateList: _ctx.getFormReset,
      sale_order_number: _ctx.formData.fulfillment_order_identifier.sale_order_number,
      fulfillment_order_number: 
      _ctx.formData.fulfillment_order_identifier.fulfillment_order_number
    ,
      fulfilled_items: _ctx.formData.fulfilled_items,
      items: _ctx.options.fulfilled_items
    }, null, 8, ["onUpdateList", "sale_order_number", "fulfillment_order_number", "fulfilled_items", "items"]),
    _createVNode(_component_ShowFulfillmentOrderItemDetailModal, {
      itemId: Number(_ctx.editItemDetailId),
      onResetForm: _ctx.handleItemDetail
    }, null, 8, ["itemId", "onResetForm"])
  ], 64))
}